// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"); */

.navHeaderContainer_EKboo {
  display: flex;
  width: 100%;
  height: 100vh; 
  justify-content: center;
  align-items: center;
  flex-direction: column;

  font-family: "Inter", sans-serif;
  background-size: cover;
  align-self: center;
  position: relative;
  box-sizing: border-box;
  
  .logo_zsBc8 {
    width: clamp(145px, 10vw, 250px);
    stroke: #10A37F;
  }
}

.iconfloat_WHnVL {
  position: absolute;
  top: 35%;
  right: 17%;
  height: 80px;
  width: 80px;
}

@media (max-width: 900px) {
  .starIconR_fqdEp {
    top: 20%;
    right: 10%;
  }
}
@media (max-width: 315px) {
  .starIconR_fqdEp {
    display: none;
  }
}

.navButtons_Ej9mD{
  margin-top: 40px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  .button_pWBQn{
    height: 57px;
    min-width: fit-content;
    cursor: pointer;
    background: #2C2C2C;
    color: #FFFFFF;
    font-size: 15px;
    border: none;
    outline: none;
    font-weight: 500;
    padding: 12px 28px;
    border-radius: 99px;
    -webkit-border-radius: 99px;
    -moz-border-radius: 99px;
    -ms-border-radius: 99px;
    -o-border-radius: 99px;
    display: flex;
    align-items: center;
    gap: 5px;
    svg{
      height: 15px;
      width: 15px;
    }
}
}

@media (max-width: 515px) {
  .navButtons_Ej9mD {
    flex-direction: column;
  }
}

.navHeaderTitle_hZNX2 {
  font-size: clamp(20px, 3vw, 11vw); 
  text-align: center;
  font-weight: 500;
  background: linear-gradient(90deg, #00ffc3 0%, #222222 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #222;
  margin: 20px 0;
}

.navHeaderSubtitle_Zyyfb {
  font-weight: 700;
  font-size: clamp(8rem, 9vw, 11vw); 

  .factura_KQiaa {
    background: linear-gradient(90deg, #16c098 0%, #0a5a47 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: var(--_16c098-color);
    font-weight: 600;
    text-transform: capitalize;
  }
  .gpt_S7j00 {
    background: linear-gradient(90deg, #0f5443 66%, #222222 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: var(--_16c098-color);
    font-weight: 700;
  }

  span {
    color: var(--_2-color);
  }
}
@media (max-width: 768px) {
  .navHeaderContainer_EKboo {
    padding-top: 30px;
    justify-content: center;
    gap: 30px;
  }
  .navHeaderSubtitle_Zyyfb {
    font-size: 16vw; 
    margin-top: 0;
  }
}


.videoPopupOverlay_cqN2F {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.videoPopupContent_fvEaZ {
  position: relative;
  background: var(--white-color);
  padding: 20px;
  border-radius: 10px;
  width: 800px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 4px 20px var(--_00000033-shadow);
}

.videoWrapper_If7oy {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; 
  overflow: hidden;
}

.video_I2phU {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.closeButton_SOeIA {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  z-index: 1;
  padding: 5px 10px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.closeButton_SOeIA:hover {
  background: var(--_0000001a-shadow);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NavHeader/NavHeader.module.css"],"names":[],"mappings":"AAAA,qGAAqG;;AAErG;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;;EAEtB,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;;EAEtB;IACE,gCAAgC;IAChC,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT;IACE,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR;MACE,YAAY;MACZ,WAAW;IACb;AACJ;AACA;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,4DAA4D;EAC5D,6BAA6B;EAC7B,oCAAoC;EACpC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;;EAEjC;IACE,4DAA4D;IAC5D,6BAA6B;IAC7B,oCAAoC;IACpC,2BAA2B;IAC3B,gBAAgB;IAChB,0BAA0B;EAC5B;EACA;IACE,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,eAAe;IACf,aAAa;EACf;AACF;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["/* @import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\"); */\n\n.navHeaderContainer {\n  display: flex;\n  width: 100%;\n  height: 100vh; \n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n  font-family: \"Inter\", sans-serif;\n  background-size: cover;\n  align-self: center;\n  position: relative;\n  box-sizing: border-box;\n  \n  .logo {\n    width: clamp(145px, 10vw, 250px);\n    stroke: #10A37F;\n  }\n}\n\n.iconfloat {\n  position: absolute;\n  top: 35%;\n  right: 17%;\n  height: 80px;\n  width: 80px;\n}\n\n@media (max-width: 900px) {\n  .starIconR {\n    top: 20%;\n    right: 10%;\n  }\n}\n@media (max-width: 315px) {\n  .starIconR {\n    display: none;\n  }\n}\n\n.navButtons{\n  margin-top: 40px;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  .button{\n    height: 57px;\n    min-width: fit-content;\n    cursor: pointer;\n    background: #2C2C2C;\n    color: #FFFFFF;\n    font-size: 15px;\n    border: none;\n    outline: none;\n    font-weight: 500;\n    padding: 12px 28px;\n    border-radius: 99px;\n    -webkit-border-radius: 99px;\n    -moz-border-radius: 99px;\n    -ms-border-radius: 99px;\n    -o-border-radius: 99px;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    svg{\n      height: 15px;\n      width: 15px;\n    }\n}\n}\n\n@media (max-width: 515px) {\n  .navButtons {\n    flex-direction: column;\n  }\n}\n\n.navHeaderTitle {\n  font-size: clamp(20px, 3vw, 11vw); \n  text-align: center;\n  font-weight: 500;\n  background: linear-gradient(90deg, #00ffc3 0%, #222222 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: #222;\n  margin: 20px 0;\n}\n\n.navHeaderSubtitle {\n  font-weight: 700;\n  font-size: clamp(8rem, 9vw, 11vw); \n\n  .factura {\n    background: linear-gradient(90deg, #16c098 0%, #0a5a47 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    color: var(--_16c098-color);\n    font-weight: 600;\n    text-transform: capitalize;\n  }\n  .gpt {\n    background: linear-gradient(90deg, #0f5443 66%, #222222 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    color: var(--_16c098-color);\n    font-weight: 700;\n  }\n\n  span {\n    color: var(--_2-color);\n  }\n}\n@media (max-width: 768px) {\n  .navHeaderContainer {\n    padding-top: 30px;\n    justify-content: center;\n    gap: 30px;\n  }\n  .navHeaderSubtitle {\n    font-size: 16vw; \n    margin-top: 0;\n  }\n}\n\n\n.videoPopupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(5px);\n}\n\n.videoPopupContent {\n  position: relative;\n  background: var(--white-color);\n  padding: 20px;\n  border-radius: 10px;\n  width: 800px;\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 4px 20px var(--_00000033-shadow);\n}\n\n.videoWrapper {\n  position: relative;\n  width: 100%;\n  height: 0;\n  padding-bottom: 56.25%; \n  overflow: hidden;\n}\n\n.video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.closeButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #333;\n  z-index: 1;\n  padding: 5px 10px;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.closeButton:hover {\n  background: var(--_0000001a-shadow);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navHeaderContainer": `navHeaderContainer_EKboo`,
	"logo": `logo_zsBc8`,
	"iconfloat": `iconfloat_WHnVL`,
	"starIconR": `starIconR_fqdEp`,
	"navButtons": `navButtons_Ej9mD`,
	"button": `button_pWBQn`,
	"navHeaderTitle": `navHeaderTitle_hZNX2`,
	"navHeaderSubtitle": `navHeaderSubtitle_Zyyfb`,
	"factura": `factura_KQiaa`,
	"gpt": `gpt_S7j00`,
	"videoPopupOverlay": `videoPopupOverlay_cqN2F`,
	"videoPopupContent": `videoPopupContent_fvEaZ`,
	"videoWrapper": `videoWrapper_If7oy`,
	"video": `video_I2phU`,
	"closeButton": `closeButton_SOeIA`
};
export default ___CSS_LOADER_EXPORT___;
